<template>
  <div class="chat_action">
    <input type="image"
           src="static/images/chat/chat_bubble.svg"
           @click.prevent="chat()"
           alt="Submit">
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'chat-bubble',
  props: {
    username: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapMutations('users', [
      'setSelectedUser',
    ]),
    ...mapMutations('common', [
      'toggleNeedLoad',
    ]),
    ...mapActions('users', [
      'searchUsers',
    ]),
    chat() {
      if (!this.getSearchedUsers[this.username]) {
        this.toggleNeedLoad({ value: true });
        this.searchUsers({ username: this.username }).then(() => {
          this.toggleNeedLoad({ value: false });
          this.goToChat();
        });
      } else this.goToChat();
    },
    goToChat() {
      this.setSelectedUser(this.username);
      this.$router.push({ name: 'chat' });
    },
  },
  computed: {
    ...mapGetters('users', [
      'getSearchedUsers',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/shared/ChatBubble.vue